import type { TypographyProps } from "@mui/material";
import TextHighlight from "components/TextHighlight";
import Typography from "components/Typography";
import useSearchText from "providers/SearchTextProvider/useSearchText";

interface TypographyHighlightProps extends Omit<TypographyProps, "children"> {
  children: string;
}

/**
 * A Typography component that highlights the search text within its children.
 * Should be used within a SearchTextProvider context.
 *
 * - Children should be a string.
 * - Other props are passed to the underlying Typography component.
 */
function TypographyHighlight(props: TypographyHighlightProps) {
  const { children, ...rest } = props;
  const searchedText = useSearchText();
  return (
    <Typography {...rest}>
      <TextHighlight text={children} searchText={searchedText} />
    </Typography>
  );
}

export default TypographyHighlight;
